import pluralize from 'pluralize';
import capitalize from 'lodash/capitalize';

import { Heading16 } from 'approot/shared/styles/typography.style';
import Text from 'approot/shared/styles/typography/text';

type Props = {
  proficiencies: string[];
};

const ProficienciesView = ({ proficiencies }: Props) => {
  if (!proficiencies || proficiencies.length === 0) {
    return null;
  }

  return (
    <>
      <Heading16 as="h3" marginBottom={0} marginTop={12}>
        {pluralize('Maths Proficiency', proficiencies.length)}
      </Heading16>
      <Text>
        {proficiencies
          .map(p => capitalize(p))
          .sort()
          .join(', ')}
      </Text>
    </>
  );
};

export default ProficienciesView;
